import { onMount } from "@/modules/_";
import PixelGrid from "@/classes/PixelGrid";

export default function (element: HTMLElement, dataset: DOMStringMap) {
  onMount(() => {
    new PixelGrid().init();
  });
}
